import { ReactNode, useEffect, useState } from "react";
import { BasicUser } from "types/topicflow";

import Avatar from "@components/avatar/avatar";
import Button, { ButtonSize, buttonTheme } from "@components/button/button";
import { TableBodyCell } from "@components/table/table";
import { TopicflowIcon } from "@components/topicflow-icon/topicflow-icon";
import { classNames } from "@helpers/css";

const PerformanceAssessmentTableNameCell = ({
  target,
  isEmployeeDrawerOpen,
  actionDropdown,
  viewCalibrations,
  onOpenEmployeeDrawer,
  isFirst,
}: {
  target: BasicUser;
  isEmployeeDrawerOpen: boolean;
  onOpenEmployeeDrawer: () => void;
  actionDropdown?: ReactNode;
  viewCalibrations?: ReactNode;
  isFirst?: boolean;
}) => {
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (isEmployeeDrawerOpen) {
      // hide the hovered state when the employee drawer is open
      setIsHovered(false);
    }
  }, [isEmployeeDrawerOpen]);

  return (
    <TableBodyCell
      isFirst={isFirst}
      onMouseEnter={() => !isEmployeeDrawerOpen && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="min-w-56 relative">
        {isHovered && (
          <div
            className={classNames(
              "absolute inset-y-0 z-10 flex flex-col justify-center",
              !!actionDropdown && !!viewCalibrations
                ? "right-[4.5rem]"
                : !!actionDropdown || !!viewCalibrations
                ? "right-9"
                : "right-0"
            )}
          >
            <div className="bg-white border rounded-md">
              <Button
                size={ButtonSize.medium}
                theme={buttonTheme.iconGray}
                onClick={onOpenEmployeeDrawer}
              >
                <TopicflowIcon type="sidebar" className="w-4 h-4" />
                OPEN
              </Button>
            </div>
          </div>
        )}

        <div className="flex items-center justify-between min-w-36">
          <div className="flex items-center">
            <Avatar className="mr-2" size="6" user={target} /> {target.name}
          </div>
          <div className="flex shrink-0 items-center">
            {viewCalibrations}
            {actionDropdown}
          </div>
        </div>
      </div>
    </TableBodyCell>
  );
};

export default PerformanceAssessmentTableNameCell;
